module.exports = __webpack_public_path__ + "img/wx_qrcode.d69aecdb.png";